import { divIcon } from "leaflet";
import moment from "moment";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const PlannedMarkerWrap = ({ item, estimatedAt }) => {
    return (
        <Marker
            position={[item.y, item.x]}
            zIndexOffset={-50}
            icon={divIcon({
                iconSize: [28, 82],
                className: "map__icon map-icon map-icon--blue-track map-icon--car map-icon--blue",
            })}
        >
            <Tooltip className="map__tooltip" direction="top">
                <div>Плановая точка нахождения машины</div>
                {estimatedAt && <div>Дата последнего расчета: {moment(estimatedAt).format("DD.MM.YY H:mm")}</div>}
            </Tooltip>
        </Marker>
    );
};

export default PlannedMarkerWrap;
